<template>
  <div class="activity-recharge">
    <div class="tab-box">
      <div class="tab-item" 
        v-for="item in tabList" :key="item.walletType" 
        :class="{active: walletType == item.walletType}"
        @click="switchTab(item)"
      >
        {{item.name}}
      </div>
    </div>
    <div class="header-box">
      <div class="wallet-name">{{title}}余额(元)</div>
      <div class="money"><span>￥</span>{{ balanceAmount || 0 }}</div>
      <van-button :color="isActivityEnd ? '#ccc' :'#FF6B31'" class="button" round size="small" @click="recharge" >
        {{title}}充值
      </van-button>
      <div class="matter-text">
        注意事项：<br>
        1. 微信充值将会收取一定的手续费<br>
        <span v-if="walletType != 5">2. 剩余{{title}}金额将在活动结束后原路退回<br></span>
        <span v-else>2. 剩余抽奖金额待抽奖结束且所有涉及到钱的奖品都已发放完毕后才将原路退回</span>
      </div>
    </div>
    <div class="record" @click="jump('use')">{{title}}使用记录</div>
    <div class="record" @click="jump('recharge')">{{title}}充值记录</div>
    <recharge-dialog v-if="isShowRecharge" :title="title" :visible.sync="isShowRecharge" />
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
import rechargeDialog from '../activity-management/components/recharge-dialog'
export default {
  name: "activityRecharge",
  components: {
    refreshList,
    rechargeDialog
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    },
    isActivityEnd() {
      return this.$route.query.activityStatus == 3
    }
  },
  data() {
    return {
      tabList: [
        {name: '现金红包',walletType: 2},
        {name: '裂变佣金',walletType: 4},
        {name: '抽奖',walletType: 5}
      ],
			walletType: 2,
      title: '现金红包',
      balanceAmount: 0,
      isShowRecharge: false
    }
  },
  methods: {
    recharge() {
      if (!this.isActivityEnd) {
        this.isShowRecharge = true
      }
    },
    getActivityWalletBalance() {
      let parmes = {
        activityId: this.activityId,
        walletType: this.walletType
      }
      this.$api.luckDraw.getActivityWalletBalance(parmes).then(res => {
        this.balanceAmount = res.data
      })
    },
    switchTab(item) {
      this.walletType = item.walletType
      this.title = item.name
      this.getActivityWalletBalance()
    },
    jump(type) {
      let pathMap = { 
        use: '/usage-record',
        recharge: '/recharge-records'
      }
      this.$router.push({
        path: pathMap[type],
        query: {
          activityId: this.activityId,
          walletType: this.walletType
        }
      })
    }
  },
  created() {
    this.getActivityWalletBalance()
  }
}
</script>

<style lang="stylus">
.activity-recharge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .tab-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 44px;
    background: #fff;
    .tab-item {
      flex: 1
      text-align: center;
      line-height: 44px;
      color: #999999;
      border-right: 1px solid #E5E5E5;
    }
    .tab-item:last-child{
      border-right: none;
    }
    .active {
      color: #FF6B31;
      background: #FFF2ED;
    }
  }
  .header-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .wallet-name {
      color: #333333;
    }
    .money {
      color: #FF6B31;
      font-weight: 600;
      font-size: 24px;
      margin-top: 10px;
      span {
        font-size: 16px;
      }
    }
    .button {
      margin-top: 10px;
    }
    .matter-text {
      width: 300px;
      line-height 1.5
      margin-top: 20px;
    }
  }
  .record {
    margin-top: 20px;
    color: #ff6b31;
    width: 120px;
  }
}
</style>